// Reverb (websocket) contract for Campaign Wizard runs — mirrors auditsRealtime.js.
// The Echo instance is already configured in src/util/echo.js (Bearer + X-Tenant
// authorizer); `useEcho` subscribes to the private channel below.

// Build-time flag: realtime only wires up when a Reverb key is present.
export const REVERB_ENABLED = Boolean(process.env.REACT_APP_REVERB_KEY);

// Private channel per run + the single status event (payload: `{ runId, status, … }`).
export const wizardRunChannel = (id) => `campaign-wizard.${id}`;
export const WIZARD_RUN_STATUS_EVENT = '.status.updated';

export const WIZARD_RUN_STATUS = {
  QUEUED: 'queued',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
};

export const isFinishedRunStatus = (status) =>
  status === WIZARD_RUN_STATUS.COMPLETED || status === WIZARD_RUN_STATUS.FAILED;

// A completed run's per-field reasons (`reasonsStatus`, on the run and the status event). The
// ML writes them after the draft, so a run completes with them `pending` and broadcasts once
// more when they land (`complete`) or the BE gives up (`unavailable`). `none`: no reasons.
export const WIZARD_REASONS_STATUS = {
  NONE: 'none',
  PENDING: 'pending',
  COMPLETE: 'complete',
  UNAVAILABLE: 'unavailable',
};

export const isReasonsPending = (status) => status === WIZARD_REASONS_STATUS.PENDING;

// Poll cadence while the socket is down (matches the Audits listener).
export const RUN_POLL_INTERVAL_MS = 5000;

// Slower poll kept up even while the socket is live: a status event can be missed (sent
// before the channel subscribed, or the job's best-effort broadcast failed), and nothing
// else would read the run again.
export const RUN_SAFETY_POLL_INTERVAL_MS = 15000;

// Generation takes 25–100 s, so give up well past that.
export const RUN_TIMEOUT_MS = 4 * 60 * 1000;
